document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('deferred-media').forEach(function (el) {
    // Modal/popup ke andar wale deferred-media ko skip karo
    if (el.closest('.product-media-modal, [id^="ProductModal-"], modal-dialog')) {
      return;
    }
    if (typeof el.loadContent === 'function') {
      el.loadContent(true);
    }
  });

  setTimeout(function () {
    document.querySelectorAll('deferred-media video').forEach(function (v) {
      // Sirf visible video ko autoplay karo, hidden wale ko chhodo
      if (v.offsetParent === null) return; // hidden element, skip

      v.muted = true;
      v.setAttribute('muted', '');
      v.loop = true;
      v.playsInline = true;
      v.play().catch(function (err) {
        console.log('Autoplay blocked:', err);
      });
    });
  }, 500);
});